import React from "react";
import loading from "../../img/loading.gif";

const LoadingOverlay = ({ isLoading }) => {
  return (
    <div
      className="loading-overlay"
      style={{ display: isLoading ? "flex" : "none" }}
    >
      <img src={loading} alt=""  />
    </div>
  );
};

export default LoadingOverlay;
